
import { Mixins, Component, Watch, Ref } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
import Resize from "@/mixins/resize";
import ETable from '@/components/ETable.vue';
import EditDialog from "./weightEditDialog.vue";

@Component({ name: 'two-hour-components-WeightManagement', components: { ETable, EditDialog } })
export default class WeightManagement extends Mixins(tablePagination, loading, Resize) {

    columns = [
        { prop: "time", label: "时间区间", width: "120px" },
        { prop: "name", label: "时辰", width: "100px" },
        { prop: "fatReduction", label: "减脂必做" },
        { prop: "fatGain", label: "发胖雷区" },
        { prop: "fatCore", label: "减脂核心" },
        { prop: "fatPrinciple", label: "减脂原理" },
        { prop: "modifiedBy", label: "操作人", width: "100px" },
        { prop: "modifiedTime", label: "最后操作时间", width: "160px" },
        { prop: "action", label: "操作", width: "100px" },
    ];

    tableData = [];

    id = "";
    EditDialogVisible = false;

    mounted() {
        this.getData();
        this.windowResize();
    }

    getData() {
        this.showLoading();
        // TODO: 替换为实际的体重管理接口
        // getWeightList().then((res) => {
        //     this.tableData = res.data;
        // }).finally(() => {
        //     this.hideLoading();
        // });
        this.tableData = [];
        this.hideLoading();
    }

    handleEdit(row) {
        this.id = row.id;
        this.EditDialogVisible = true;
    }

    editConfirm() {
        this.getData();
        this.EditDialogVisible = false;
    }
}
